const ACTION_TYPES = {
    SET_DATA: 'SET_DATA'
};

const initialState = {
    isInitialized: false,
    data: []
};

const reducer = function (state = initialState, { type, payload }) {
    switch (type) {
        case ACTION_TYPES.SET_DATA:
            return Object.assign({}, state, {
                isInitialized: true,
                data: payload
            });

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
